import { AxiosInstance } from 'axios';

import { UsersAPIApiFactory } from '@cast/openapi';
import { IdentityAPIApiFactory } from '@cast/openapi-organization-management';

import { AXIOS_CONFIGURATION } from '../constants';

export const UsersApiAdapter = (client: AxiosInstance) => {
  const generatedApi = UsersAPIApiFactory(AXIOS_CONFIGURATION, '', client);
  const identityApi = IdentityAPIApiFactory(AXIOS_CONFIGURATION, '', client);

  return {
    currentUserProfile: generatedApi.usersAPICurrentUserProfile,
    listOrganizations: generatedApi.usersAPIListOrganizations,
    createOrganization: generatedApi.usersAPICreateOrganization,
    updateOrganization: generatedApi.usersAPIEditOrganization,
    deleteOrganization: generatedApi.usersAPIDeleteOrganization,
    listInvitations: generatedApi.usersAPIListInvitations,
    claimInvitation: generatedApi.usersAPIClaimInvitation,
    createInvitation: generatedApi.usersAPICreateInvitations,
    deleteInvitation: generatedApi.usersAPIDeleteInvitation,
    getOrganizationUsers: generatedApi.usersAPIListOrganizationUsers,
    deleteOrganizationUser: generatedApi.usersAPIRemoveUserFromOrganization,
    bulkDeleteOrganizationUsers: generatedApi.usersAPIRemoveOrganizationUsers,
    setFingerprint: identityApi.identityAPISetFingerprint,
  };
};
